<template>

  <div class="tutorial">
    <v-progress-circular class="loader" indeterminate color="primary" :size="50" v-if="loading"></v-progress-circular>
    <v-tour name="default" :steps="steps" :callbacks="callbacks"></v-tour>
    <div class="tutorial-overlay" ref="overlay" :class="{ active: visible || loading }"></div>
  </div>

</template>

<script>
const HISTORY_INDEX = 'tutorial'

export default {
  name: 'tutorial',
  props: [ 'scenario' ],
  data () {
    return {
      visible: false,
      loading: false,
      tutorial: null,
      callbacks: {
        onPreviousStep: index => this.stepUpdate(index - 1),
        onNextStep: index => this.stepUpdate(index + 1),
        onStart: () => {
          this.stepUpdate(0)
        },
        onStop: () => {
          this.visible = false
        }
      },
      labels: {
        buttonSkip: this.$t('tutorial.labels.skip'),
        buttonPrevious: this.$t('tutorial.labels.previous'),
        buttonNext: this.$t('tutorial.labels.next'),
        buttonStop: this.$t('tutorial.labels.finish')
      }
    }
  },
  computed: {
    available () {
      return !!this.steps.length
    },
    steps () {
      return this.tutorial && this.tutorial.steps ? this.tutorial.steps : []
    },
    newer () {
      const current = this.history[this.scenario]

      return !current || current < this.tutorial.version
    },
    history () {
      return JSON.parse(window.localStorage.getItem(HISTORY_INDEX)) || {}
    }
  },
  methods: {
    start () {
      this.updateHistory()
      this.$tours['default'].start()
    },
    stepUpdate (current) {
      this.visible = true

      const element = document.querySelector(this.steps[current].target)

      if (!element) {
        return
      }

      const offset = this.absoluteOffset(element)

      // rectangular
      const style = this.$refs.overlay.style
      style.left = offset.left + 'px'
      style.top = offset.top + 'px'
      style.width = element.offsetWidth + 'px'
      style.height = element.offsetHeight + 'px'

      // circular
      /*
      const size = Math.max(element.offsetWidth, element.offsetHeight);
      const style = this.$refs.overlay.style
      style.left = (offset.left + element.offsetWidth / 2 - size / 2) + 'px'
      style.top = (offset.top + element.offsetHeight / 2 - size / 2) + 'px'
      style.width = size + 'px'
      style.height = size + 'px'
      style['border-radius'] = '50%'
      */
    },
    absoluteOffset (element) {
      let top = 0
      let left = 0

      do {
        top += element.offsetTop || 0
        left += element.offsetLeft || 0
        element = element.offsetParent
      } while (element)

      return {
        top,
        left
      }
    },
    updateHistory () {
      const history = this.history
      history[this.scenario] = this.tutorial.version

      window.localStorage.setItem(HISTORY_INDEX, JSON.stringify(history))
    },
    reload () {
      this.tutorial = null

      const tutorial = require('../../tutorials/assets.json')

      tutorial.steps = tutorial.steps
        .map(step => ({
          target: ('.router-view [data-tutorial="' + step.identifier + '"]' + ' ' + (step.selector || '')).trim(),
          content: this.stepContent(step)
        }))
        .filter(step => !!document.querySelector(step.target))

      this.tutorial = tutorial

      if (this.available && this.newer && !!this.tutorial.autostart) {
        this.start()
      }
    },
    stepContent (step) {
      if (!step.content) {
        return this.$t('tutorial.scenario.' + this.scenario + '.' + step.identifier)
      }

      if (/^tutorial\.scenario(\..+){2,}/.test(step.content)) {
        return this.$t(step.content)
      }

      return step.content
    }
  },
  watch: {
    scenario () {
      this.reload()
    },
    steps () {
      this.$emit('available', this.available)
    }
  },
  mounted: function () {

  }
}
</script>

<style scoped lang="scss">
$z-index: 10000;

.tutorial {
  .v-tour {
    z-index: $z-index;

    ::v-deep {
      .v-step {
        z-index: $z-index + 1;
        filter: none;
        border-radius: 0px;
        border: 1px solid #555;
        background-color: #288bc5;

        .v-step__arrow {
          border-color: #555;
        }

        &[x-placement^=bottom] {
          margin-top: 2.3rem;

          .v-step__arrow {
            border-left-color: transparent;
            border-right-color: transparent;
            border-top-color: transparent;
          }
        }

        &[x-placement^=top] {
          margin-bottom: 2.3rem;

          .v-step__arrow {
            border-bottom-color: transparent;
            border-left-color: transparent;
            border-right-color: transparent;
          }
        }
      }
    }
  }

  .loader {
    position: absolute;
    top: 50vh;
    left: 50vw;
    z-index: $z-index + 1;
  }

  .tutorial-overlay {
    content: ' ';
    display: none;
    position: fixed;
    left: 300px;
    top: 300px;
    width: 0px;
    height: 0px;
    z-index: $z-index - 1;
    box-shadow: 0 0 0 1000em rgba(black, .5);

    border: 1px solid #555;
    padding: 20px;
    margin: -20px;
    box-sizing: content-box;

    &.active {
      display: block;
    }
  }
}
</style>
